import React from 'react';
import { useTheme, withStyles, WithStyles } from '@material-ui/core';
import { Typography } from '@mui/material';
import styles from './VTypography.styles';
import { VTypographyBaseProps } from './interfaces';

const VTypography = ({
  classes,
  style,
  children,
  linesNumber = undefined,
  className = '',
  align = 'left',
  color,
  variant = 'body1',
  ...typographyProps
}: VTypographyBaseProps & WithStyles<typeof styles>) => {
  const theme = useTheme();

  return (
    <Typography
      component="span"
      textAlign={align}
      color={color || theme.palette.text.primary}
      variant={variant}
      className={`${classes.base} ${classes[variant]} ${className}`}
      style={{ lineClamp: linesNumber, WebkitLineClamp: linesNumber, ...style }}
      {...typographyProps}
    >
      {children}
    </Typography>
  );
};

export default withStyles(styles)(VTypography);
